import { defineMessages } from 'react-intl-next';

export default defineMessages({
	dismissButtonAria: {
		id: 'growth-checklist.dismissButtonAria',
		defaultMessage: 'Dismiss {title}',
		description: 'Text for screen readers only to describe that this will dismiss the button.',
	},
});
